import { render, staticRenderFns } from "./assetTypePermission.vue?vue&type=template&id=06c47b98&scoped=true&"
import script from "./assetTypePermission.vue?vue&type=script&lang=js&"
export * from "./assetTypePermission.vue?vue&type=script&lang=js&"
import style0 from "./assetTypePermission.vue?vue&type=style&index=0&id=06c47b98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c47b98",
  null
  
)

export default component.exports